































import { Component, Vue } from 'vue-property-decorator'
import { ITutorialSlide } from '../../../../components/Tutorial.vue'

@Component({
  components: {
    Tutorial: require('@/components/Tutorial').default
  }
})
export default class CuepointGenerator extends Vue {
  tutorialSlides: ITutorialSlide[] = [
    {
      html: `The <strong>Cue Point Generator</strong> can analyze your tracks and set cue points where you want them. The real gem here is <strong>drop detection</strong> which is an algorithm that can determine where in the track the drop, breakdown and end is. Based on this information, you can add custom cue points anywhere in the track.<br><br>In this tutorial, I'm going to show you how to generate cue points for a few tracks.<br><br>It's important to realize that the Cue Point Generator is a tool for bulk analyzing. Not every cue point will be perfect, this really depends on the genre of the track.`
    },
    {
      image: 'cpg1.png',
      html: `I'm going to analyze a few Drum & Bass tracks so I'm selecting <strong>drop detection</strong> here. You can use drop detection for almost any type of electronic music. If your music is more focused on vocals or there is no strict "drop" in the track, <strong>Musical Changes</strong> may be better suited.`
    },
    {
      image: 'cpg2.png',
      html: `I've selected a few tracks from my Drum & Bass playlist and now I get to this interesting screen. By default, rekordcloud will analyze and add cue points at the standard points. These are the start, drop, breakdown, second drop, second breakdown and end.<br>You can re-order these points and change their names, colors and type of cue.<br><br>But this isn't quite what I want when I'm performing, so let's change these to my personal preference.`
    },
    {
      image: 'cpg3.png',
      html: `Now it's starting to look useful! I've added a cue point 64 beats before the drop and 32 beats before the breakdown. I also added an emergency loop 16 beats before the end, just in case I run out of time to mix.<br><br>I left the colors as they are this time, but normally I'd have a system where colors have a certain meaning (which I encourage you to adopt too!).<br>All I have to do now is start the process and let rekordcloud analyze. After downloading the new library, cue points appear, almost like magic!<br><br>That's the end of the tutorial. I hope this saves you a lot of time!`
    }
  ]
}
